import React from 'react'
import PhotoGrid from '../../../../components/ImageView'
import { images } from '../../../../common/staticData'

const SurveyorDetails = () => {
  return (
    <div>
        <p className='text-[14px] font-[700] '>Surveyor Details</p>
    <div className='grid grid-cols-2 gap-4'>
      <div className='grid grid-cols-2 gap-4 border-r-2 border-dashed'>
        <div>
            <div >
            <p className='text-[14px]'>Pickup Yard</p>
            <p className='text-[14px] font-[500] text-[#444FBD]'>Yard Name</p>   
            </div>
            <div >
            <p className='text-[14px]'>Location</p>
            <p className='text-[14px]'>Chennai, India</p>   
            <p className='text-[14px]'>30 July 2024, 06:16pm</p>   
            </div>
            <div >
            <p className='text-[14px]'>Condition</p>
            <p className='text-[14px]u'>Good</p>  
            <PhotoGrid images={images} /> 
            </div>
        </div>

        <div>
            <div >
            <p className='text-[14px]'>Liner </p>
            <p className='text-[14px] font-[500] text-[#444FBD]'>Ever Green Pvt Ltd</p>   
            </div>
            <div >
            <p className='text-[14px]'>Surveyor</p>
            <p className='text-[14px] font-[500] text-[#444FBD]'>Praveen Elumalai</p>  
            </div>
            <div >
            <p className='text-[14px]'>Company</p>
            <p className='text-[14px] font-[500] text-[#444FBD]'>Kittivaasal Technologies Pvt Ltd</p>   
            <p className='text-[14px]'>+91 898687554378</p>   
            <p className='text-[14px]'>praveenfly22@gmail.com</p>   
            </div>
        </div>
      </div>
      <div className='grid grid-cols-2 gap-4'>
        <div>
            <div >
            <p className='text-[14px]'>Pickup Yard</p>
            <p className='text-[14px] font-[500] text-[#444FBD]'>Yard Name</p>   
            </div>
            <div >
            <p className='text-[14px]'>Location</p>
            <p>Chennai, India</p>   
            <p>30 July 2024, 06:16pm</p>   
            </div>
            <div >
            <p className='text-[14px]'>Condition</p>
            <p>Good</p>  
            <PhotoGrid images={images} />  
            </div>
        </div>

        <div>
            <div >
            <p className='text-[14px]'>Liner </p>
            <p className='text-[14px] font-[500] text-[#444FBD]'>Ever Green Pvt Ltd</p>   
            </div>
            <div >
            <p className='text-[14px]'>Surveyor</p>
            <p className='text-[14px] font-[500] text-[#444FBD]'>Praveen Elumalai</p>  
            </div>
            <div >
            <p className='text-[14px]'>Company</p>
            <p className='text-[14px] font-[500] text-[#444FBD]'>Kittivaasal Technologies Pvt Ltd</p>   
            <p className='text-[14px]'>+91 898687554378</p>   
            <p className='text-[14px]'>praveenfly22@gmail.com</p>   
            </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default SurveyorDetails
